export default __webpack_public_path__ + "static/media/logo-factura.0a0f9b29.png";